/*
 * @Author       : Archer<ahh666@qq.com>
 * @Date         : 2023-03-06 14:09:55
 * @LastEditors: wuzijia wuzijia1230@qq.com
 * @LastEditTime: 2023-07-20 20:23:52
 * @FilePath     : \youxi\youxi\src\util\im.js
 * @Description  : Description
 */

import store from "@/store";
import * as RongIMLib from "@rongcloud/imlib-next";
import { getAllGroupInfoApi, userLogin } from "../request/im";
import { Message } from "element-ui";
import debounce from "lodash/debounce";
import { openIM } from "./openIM";
import Vue from "vue";

const { VUE_APP_IM_APP_KEY } = process.env;

const appkey = VUE_APP_IM_APP_KEY;

RongIMLib.init({ appkey });

// 注册自定义消息类型（与 im-chat-backend MsgConstans.php 保持一致）
RongIMLib.registerMessageType('PX:EvaluationMsg', true, true, ['group_id', 'score', 'content', 'tags'])
RongIMLib.registerMessageType('PX:OrderMsg', true, true, ['order_id', 'status', 'content', 'price', 'title', 'img'])
RongIMLib.registerMessageType('PX:ProductMsg', true, true, ['product_id', 'title', 'img', 'price', 'game_id'])
RongIMLib.registerMessageType('PX:ReminderMsg', true, false, ['content', 'type', 'target_id'])
RongIMLib.registerMessageType('PX:SpeakMsg', false, false, ['action', 'target_id', 'content'])
RongIMLib.registerMessageType('PX:ActiveConversation', false, false, ['group_id', 'type'])
RongIMLib.registerMessageType('PX:ConvenientMsg', true, true, ['content', 'title'])
RongIMLib.registerMessageType('PX:ProfileMsg', true, true, ['user_id', 'nickname', 'portrait'])
RongIMLib.registerMessageType('PX:CombineMsg', true, true, ['content', 'summary', 'title'])
RongIMLib.registerMessageType('PX:AfterSalesMsg', true, true, ['order_id', 'type', 'content'])

const getIMUserToken = async () => {
  const { telphone, nickname, touxiang, user_id, user_sn } = JSON.parse(
    localStorage.getItem("userData")
  );
  if (!telphone) {
    return false;
  }
  return await userLogin({
    phone: telphone,
    name: nickname,
    portrait: touxiang,
    main_user_id: user_id,
    user_sn,
  }).then(res => {
    localStorage.setItem("USER_IM_PHONE", telphone);
    localStorage.setItem("USER_IM_INFO", JSON.stringify(res.data));
    return res.data;
  });
};

export const IMDisconnect = () => RongIMLib.disconnect().then(() => {
  console.log("IM链接已断开!");
});

// 添加事件监听
const Events = RongIMLib.Events;

let msgTotal = 0;
// 获取会话总计
const getAllConversation = async () =>
  RongIMLib.getConversationListByTimestamp({ count: 1000, startTime: 0 }).then(
    ({ code, data }) => data.length || 0
  );
// 获取并同步消息未读数
const getUnreadMessageCount = () =>
  RongIMLib.getConversationListByTimestamp({ count: 1000, startTime: 0 }).then(({ code, data }) => {
    code === 0 &&
      store.commit(
        "set_unReadMessage",
        data?.length
          ? data.reduce((acc, cur) => acc + cur.unreadMessageCount, 0)
          : 0
      );
  });
export const imInit = debounce(async () => {
  console.log(5551);
  const IMUserInfo = await getIMUserToken();
  if (!IMUserInfo) {
    return false;
  }
  const { token, rongyun_token } = IMUserInfo;
  await RongIMLib.disconnect().then(() => {
    console.log("成功断开");
  });
  localStorage.setItem("TOKEN_FOR_IM", token);
  RongIMLib.addEventListener(Events.CONNECTING, () =>
    console.log("正在链接服务器")
  );
  RongIMLib.addEventListener(Events.CONNECTED, () => {
    console.log("已经链接到服务器");
    getUnreadMessageCount();
  });
  RongIMLib.addEventListener(Events.MESSAGES, e => {
    console.log("收到新消息了:", e);
    const { messageType, content, targetId } = e.messages[0];
    if (messageType === "RC:GrpNtf" && content.group_type === "business") {
      const { operatorNickname, targetGroupName } = content.data;
      Vue.prototype.$confirm(
        `客服${operatorNickname}已经邀您进入群聊【${targetGroupName}】，是否直接开始对话？`,
        {
          confirmButtonText: "确认",
          cancelButtonText: '取消',
          center: true,
          showClose: false
        }
      )
        .then(() => {
          openIM({
            from: "userCenter",
            roomId: targetId
          });
        })
        .catch(() => {});
    }
    getUnreadMessageCount();
    store.commit("set_updateMsgListFlag", +new Date());
  });
  return RongIMLib.connect(rongyun_token).then(async res => {
    msgTotal = await getAllConversation();
    store.commit("set_updateMsgListFlag", +new Date());
    return res.code === RongIMLib.ErrorCode.SUCCESS;
  });
}, 600);

// 获取会话列表
export const getConversationList = async (pageSize = 10, pageNum = 1) =>
  RongIMLib.getConversationListByTimestamp({ count: pageSize * pageNum, startTime: 0 }).then(
    async ({ code, data }) => {
      console.log("会话列表：", data);
      // 统计未读消息数
      store.commit(
        "set_unReadMessage",
        data?.length
          ? data.reduce((acc, cur) => acc + cur.unreadMessageCount, 0)
          : 0
      );
      let list = [];
      if (code === 0) {
        const ids = data.map(item => item.targetId);
        await getAllGroupInfoApi({ group_ids: ids.slice(pageSize * (pageNum - 1)) }).then(res => {
          data.forEach(item => {
            const findItem = res.data?.find(it => it.id === item.targetId);
            if (!findItem) {
              return
            }
            Object.assign(item, findItem);
            list.push(item)
          });
        });
      }
      return {
        data: list,
        pageSize: pageSize,
        pageNum: pageNum,
        total: msgTotal
      };
    }
  );

// 清除全部会话
export const clearAllMsgUnread = () =>
  RongIMLib.getConversationListByTimestamp({ count: 1000, startTime: 0 }).then(({ code, data }) => {
    if (code === 0) {
      const unreadList = data.filter(item => item.unreadMessageCount > 0);
      unreadList.forEach((item, idx) => {
        // 多端同步
        RongIMLib.sendSyncReadStatusMessage(
          {
            conversationType: RongIMLib.ConversationType.GROUP,
            targetId: item.targetId
          },
          +new Date()
        );
        if (idx === unreadList.length - 1) {
          store.commit("set_updateMsgListFlag", +new Date());
          RongIMLib.clearAllMessagesUnreadStatus();
          Message({
            center: true,
            type: "success",
            message: "全部已读成功"
          });
        }
      });
    }
  });
